<template>
    <span :class="background" class="border border-dark-primary whitespace-nowrap rounded-l-full rounded-r-full w-fit px-1.5 mr-0.5 text-center">
        <slot></slot>
    </span>
</template>

<script>
    export default{
        name: "base-pill"
    }
</script>

<script setup>
import { computed } from 'vue';
import { defineProps } from 'vue';

const props = defineProps([
    'bgColor'
])

const background = computed(() => {
    if(props.bgColor){
        return props.bgColor
    } else {
        return 'bg-gray-100'
    }
})

</script>